module.exports = __webpack_public_path__ + "static/delta-flyer-e659ce732fe4b1ffa5bb2c2d76738c55.png";